import axios from "axios";
import { Leaderboard } from "../interfaces/leaderboard.interface";

class LeaderboardService {
    baseUrl: string;
    constructor() {
        this.baseUrl = process.env.REACT_APP_BACKEND || '';
    }
    // v1
    getAllLeaderboardPosition(userId: string, gameId: string) {
        return new Promise<Leaderboard[]>((resolve, reject) => {
            axios({
                method: 'GET',
                url: `${this.baseUrl}/game_leaderboard/api/get-all-game-leaderboard?userId=${userId}&gameId=${gameId}`,
            }).then((res: { data: { success: boolean, data: Leaderboard[] } }) => {
                if (res.data.success) {
                    resolve(res.data.data);
                } else {
                    reject(res.data.data);
                }
            }).catch((err: any) => {
                reject(err.message);
            })
        });
    }
    // v2
}

export const leaderboardService = new LeaderboardService();